import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getMyRegionHint } from '../data/me';

/** Set by the language switcher; its absence is what makes a country default safe to apply. */
export const LANGUAGE_CHOSEN_KEY = 'lang_explicit';

function languageFor(country: string): string {
  return country === 'Netherlands' ? 'nl' : 'en';
}

/**
 * Defaults the UI language from the user's Entra country, but only until they
 * say otherwise. The `oidc_lang` key cannot be used to detect a deliberate
 * choice — i18next's detector writes it on init from whatever it sniffed — so
 * an explicit marker is what holds the default back.
 */
export function useCountryLanguageDefault() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (localStorage.getItem(LANGUAGE_CHOSEN_KEY)) return;
    if (new URLSearchParams(window.location.search).has('lang')) return;

    void getMyRegionHint().then((hint) => {
      if (!hint.country) return;

      const language = languageFor(hint.country);
      if (language !== (i18n.resolvedLanguage ?? i18n.language)) {
        void i18n.changeLanguage(language);
      }
    });
  }, [i18n]);
}
